import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../src/components/Layout';
import { getHeader, getFooter } from '../src/adapters/contentful.adapter';
import CouponRetailer from '../src/components/CouponCampaign/couponretailer';

const CouponCampaignRetailer = (props) => {
    const { header, footer, pageInfo } = props;
    return (
        <div>
            <Layout header={header} footer={footer} pageInfo={pageInfo}>
                <div className="content-wrapper coupon-campaign-retailer">
                    <CouponRetailer />
                    <div id="mw-campaign">get-my-free-sample</div>
                </div>
            </Layout>
        </div>
    );
};

CouponCampaignRetailer.getInitialProps = async () => {
    const header = await getHeader();
    const footer = await getFooter();

    return {
        header,
        footer,
        pageInfo: { breadcrumbsTitle: 'サンドラッグキャンペーンクーポンページ',
            title: 'ウィスパー×サンドラックキャンペーン【全員もらえます】',
            description:
     'ウィスパー購入時にクーポンバーコード提示で200円OFF！カンタンな登録・サインインでお得なクーポンを獲得できます。',
            url: '/ウィスパー新発売記念キャンペーン',
            ogTitle: 'ウィスパー×サンドラックキャンペーン【全員もらえます】',
            ogType: 'website',
            ogDescription:
             'ウィスパー購入時にクーポンバーコード提示で200円OFF！カンタンな登録・サインインでお得なクーポンを獲得できます。',
            ogImage:
             { url:
                'https://images.ctfassets.net/8g0fievzqg8k/1xYSc0d2UTlal28HNKCF5S/f2454808263615cb9d7944c6025f6137/KOI_OPG_kv.jpg',
             width: 1201,
             height: 631,
             contentType: 'image/jpeg' },
            canonicals: { items: [{ canonical: 'https://whisper.jp/sundrug-lp2/' }] },
        },
    };
};

CouponCampaignRetailer.propTypes = {
    footer: PropTypes.object,
    header: PropTypes.object,
    pageInfo: PropTypes.object,
};

export default CouponCampaignRetailer;
